import { useGetMicrostoreColumnTemplatesQuery, MicrostoreColumnTemplateState } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import {
    microstoreColumnTemplatesColumns,
    type MicrostoreColumnTemplateRow,
} from '../constants/microstoreColumnTemplatesColumns';

type MicrostoreColumnTemplatesListProps = {
    selectedKeys: string[];
    onSelectionChange: (keys: string[]) => void;
};

export const MicrostoreColumnTemplatesList = ({
    selectedKeys,
    onSelectionChange,
}: MicrostoreColumnTemplatesListProps) => {
    const {
        loading: microstoreColumnTemplatesLoading,
        data: microstoreColumnTemplatesData,
        error: microstoreColumnTemplatesError,
    } = useGetMicrostoreColumnTemplatesQuery();

    if (microstoreColumnTemplatesLoading && !microstoreColumnTemplatesData) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!microstoreColumnTemplatesData || microstoreColumnTemplatesError) {
        throw new Error('Une erreur est survenue lors de la récupération des templates de colonne');
    }

    const { microstoreColumnTemplatesQuery: microstoreColumnTemplates } = microstoreColumnTemplatesData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<MicrostoreColumnTemplateRow>
                columns={microstoreColumnTemplatesColumns}
                data={microstoreColumnTemplates}
                filterMode="client"
                defaultFilters={{ state: [MicrostoreColumnTemplateState.Regular] }}
                getRowId={(row) => row._id}
                getRowLink={(row) => `/microstore-column-template/${row._id}`}
                searchPlaceholder="Nom du template"
                searchFilterKey="searchValue"
                enableSelection
                selectedKeys={selectedKeys}
                onSelectionChange={onSelectionChange}
            />
        </div>
    );
};
